// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[custom-header-bg] {
  padding: 5px;
}
[custom-header-bg] [no-padding-left] {
  padding-left: 0;
}

.liststyle {
  min-height: 40px !important;
}

[bg-white] {
  background: var(--ion-background-color);
}

.attach-button {
  background-color: var(--ion-header-light-background) !important;
}

.remarks-textarea {
  width: 100%;
  height: 58px;
  margin-top: 10px;
  --background-color: #f7f7f7 !important;
}

ion-card {
  margin: 10px 0px 0px 0px !important;
  width: 100% !important;
}
ion-card ion-card-content {
  padding: 0px !important;
}
ion-card ion-card-content .item span {
  padding-left: 0px !important;
}

ion-slides {
  height: auto !important;
  margin-bottom: 10px;
}

.slide-zoom ion-card ion-col {
  text-overflow: ellipsis;
  white-space: nowrap;
  width: calc(100% - 50px);
  overflow: hidden;
}

ion-slides {
  height: 100%;
}

.swiper-container {
  overflow: visible;
}

.all-copy {
  -webkit-user-select: all;
  user-select: all;
  display: block;
  margin: 0px;
  padding: 0;
  width: calc(100% - 8px - 8px);
  padding: 0;
}

.all-copy .text-input-md {
  margin: 0;
  padding: 0;
  width: calc(100% - 8px - 8px);
}

.all-copy .text-input-ios {
  margin: 0px;
  padding: 0;
  width: calc(100% - 8px - 8px);
  padding: 0;
  width: 100%;
}

.route_Name.custom-width {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.hori-scroll {
  height: 80px !important;
}
.hori-scroll ion-row {
  width: auto !important;
}

.text-style {
  font-weight: 400 !important;
}

.container {
  width: 100px;
  background-color: var(--ion-color-green);
  overflow: hidden;
  white-space: nowrap;
}
.container ::-webkit-scrollbar {
  display: none;
}
.container .scroll {
  overflow: auto;
}

.trans {
  background-color: var(--ion-header-light-background) !important;
}

@media screen and (max-width: 360px) {
  [width-5] {
    max-width: 7% !important;
  }
}
.validate-btn {
  height: 30px !important;
  max-width: 100px;
}

.attach-icon-font {
  font-size: 1.8em !important;
}

.attach-upload-row .attachment-button {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 4px 0 4px 8px;
}
.attach-upload-row .attach-btn {
  --padding-start: 0;
  --padding-end: 0;
  height: auto !important;
}
.attach-upload-row ion-icon {
  margin-right: 6px !important;
  flex-shrink: 0;
}

.attach-filename {
  white-space: normal;
  word-break: break-word;
}

.upload-col {
  flex: 0 0 auto !important;
  max-width: fit-content !important;
  padding-right: 8px !important;
}
.upload-col .validate-btn {
  margin: 0 !important;
}

.fileUploadSize {
  padding-left: 4px;
  margin-top: 2px !important;
  line-height: 1.5 !important;
  white-space: normal !important;
  word-break: break-word;
  font-size: 12px;
  padding-bottom: 6px;
}

.round_icon {
  font-size: 27px !important;
}

[custom-radio-button] {
  margin-left: auto !important;
  display: block !important;
  margin-top: 20px !important;
}

.select-disabled {
  opacity: 1;
}

.custom-right-content .validate-btn-col {
  padding: none !important;
}

.custom-margin {
  margin: 10px !important;
}

.route_Name.custom-width {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flightPlan_card button {
  margin: 0 !important;
}
.flightPlan_card .green-status-icon {
  color: var(--ion-color-green) !important;
}
.flightPlan_card .amber-status-icon,
.flightPlan_card .disabled-status-icon {
  color: var(--ion-color-amber) !important;
}
.flightPlan_card .disable-select-box,
.flightPlan_card .disabled-status-icon {
  opacity: 0.4;
}
.flightPlan_card .disabled-status-icon,
.flightPlan_card .green-status-icon,
.flightPlan_card .amber-status-icon {
  margin-left: 0;
  margin-top: 5px !important;
  margin-bottom: 5px !important;
  font-size: 2.4rem !important;
}
.flightPlan_card .download_option {
  padding: 0 0 0 15px;
}
.flightPlan_card .left-content {
  border-right: 1px solid var(--very-light-border) !important;
  padding: 0px;
}
.flightPlan_card .right-content {
  margin: auto;
  text-align: center;
}
.flightPlan_card .right-content button {
  padding: 0 5px;
}
.flightPlan_card [width-75] {
  max-width: 75% !important;
}
.flightPlan_card [width-60] {
  max-width: 60%;
}
.flightPlan_card [width-25] {
  max-width: 25% !important;
}

.slide-item-btn {
  color: var(--ion-color-primary) !important;
  background-color: var(--ion-header-bg-color) !important;
  border-right: 1px solid var(--ion-border-color) !important;
}

.slide-zoom {
  padding: 7px;
}

.item-inner {
  padding-right: none !important;
}

.dark-col-text {
  color: var(--ion-primary-text) !important;
}

.legDetailsHeader {
  padding-left: 10px;
  background: #f6f6ff;
  min-height: 33px !important;
}

.margin-bottom-10 {
  margin-bottom: 12px;
}

.padding-top-5 {
  padding-top: 5px;
}

.width-0 {
  max-width: 0%;
  padding: 0;
}

.width-10 {
  max-width: 25%;
}

.positionOfIcon {
  padding-bottom: 7px !important;
}

.trans {
  background-color: var(--ion-header-light-background) !important;
}

.delete-icon {
  margin-bottom: 4px !important;
  font-size: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/flight-plan/flight-plan.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,eAAA;AACJ;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,uCAAA;AAAF;;AAGA;EACE,+DAAA;AAAF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sCAAA;AACF;;AACA;EACE,mCAAA;EACA,sBAAA;AAEF;AAAE;EACE,uBAAA;AAEJ;AAAI;EACE,4BAAA;AAEN;;AAGA;EACE,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,iBAAA;AAAF;;AAIA;EAEE,wBAAA;EAEA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;EACA,6BAAA;AADF;;AAIA;EACE,WAAA;EACA,UAAA;EACA,6BAAA;EACA,UAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AADF;;AAIA;EACE,uBAAA;AADF;AAGE;EACE,sBAAA;AADJ;;AAKA;EACE,2BAAA;AAFF;;AAKA;EACE,YAAA;EACA,wCAAA;EACA,gBAAA;EACA,mBAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,cAAA;AAHJ;;AAOA;EACE,+DAAA;AAJF;;AAOA;EACE;IACE,wBAAA;EAJF;AACF;AAOA;EACE,uBAAA;EACA,gBAAA;AALF;;AAQA;EACE,2BAAA;AALF;;AASE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;AAPJ;AASG;EACC,4BAAA;EACA,cAAA;AAPJ;;AAUA;EACE,mBAAA;EACA,sBAAA;AAPF;;AASA;EACE,yBAAA;EACA,iCAAA;EACA,6BAAA;AANF;AAQE;EACE,oBAAA;AANJ;;AASA;EACE,iBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AANF;;AAQA;EACE,0BAAA;AALF;;AAQA;EACE,4BAAA;EACA,yBAAA;EACA,2BAAA;AALF;;AAQA;EACE,UAAA;AALF;;AASE;EACE,wBAAA;AANJ;;AAUA;EACE,uBAAA;AAPF;;AAUA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAPF;;AAWE;EACE,oBAAA;AARJ;AAWE;EACE,wCAAA;AATJ;AAYE;;EAEE,wCAAA;AAVJ;AAaE;;EAEE,YAAA;AAXJ;AAcE;;;EAGE,cAAA;EACA,0BAAA;EACA,6BAAA;EACA,4BAAA;AAZJ;AAeE;EACE,mBAAA;AAbJ;AAgBE;EACE,2DAAA;EACA,YAAA;AAdJ;AAiBE;EACE,YAAA;EACA,kBAAA;AAfJ;AAiBI;EACE,cAAA;AAfN;AAmBE;EACE,yBAAA;AAjBJ;AAoBE;EACE,cAAA;AAlBJ;AAqBE;EACE,yBAAA;AAnBJ;;AAuBA;EACE,0CAAA;EACA,uDAAA;EACA,0DAAA;AApBF;;AAuBA;EACE,YAAA;AApBF;;AAuBA;EACE,8BAAA;AApBF;;AAuBA;EACE,yCAAA;AApBF;;AAuBA;EACE,kBAAA;EACA,mBAAA;EACA,2BAAA;AApBF;;AAuBA;EACE,mBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,aAAA;EACA,UAAA;AApBF;;AAuBA;EACE,cAAA;AApBF;;AAsBA;EACE,8BAAA;AAnBF;;AAqBA;EACE,+DAAA;AAlBF;;AAoBA;EACE,6BAAA;EACA,0BAAA;AAjBF","sourcesContent":["[custom-header-bg] {\n  padding: 5px;\n\n  [no-padding-left] {\n    padding-left: 0;\n  }\n}\n\n.liststyle {\n  min-height: 40px !important;\n}\n\n[bg-white] {\n  background: var(--ion-background-color);\n}\n\n.attach-button {\n  background-color: var(--ion-header-light-background) !important;\n}\n.remarks-textarea {\n  width: 100%;\n  height: 58px;\n  margin-top: 10px;\n  --background-color: #f7f7f7 !important;\n}\nion-card {\n  margin: 10px 0px 0px 0px !important;\n  width: 100% !important;\n\n  ion-card-content {\n    padding: 0px !important;\n\n    .item span {\n      padding-left: 0px !important;\n    }\n  }\n}\n\nion-slides {\n  height: auto !important;\n  margin-bottom: 10px;\n}\n\n.slide-zoom ion-card ion-col {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  width: calc(100% - 50px);\n  overflow: hidden;\n}\n\nion-slides {\n  height: 100%;\n}\n\n.swiper-container {\n  overflow: visible;\n}\n\n// code added by shailesh for text copy\n.all-copy {\n  -moz-user-select: all;\n  -webkit-user-select: all;\n  -ms-user-select: all;\n  user-select: all;\n  display: block;\n  margin: 0px;\n  padding: 0;\n  width: calc(100% - 8px - 8px);\n  padding: 0;\n}\n\n.all-copy .text-input-md {\n  margin: 0;\n  padding: 0;\n  width: calc(100% - 8px - 8px);\n}\n\n.all-copy .text-input-ios {\n  margin: 0px;\n  padding: 0;\n  width: calc(100% - 8px - 8px);\n  padding: 0;\n  width: 100%;\n}\n\n.route_Name.custom-width {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.hori-scroll {\n  height: 80px !important;\n\n  ion-row {\n    width: auto !important;\n  }\n}\n\n.text-style {\n  font-weight: 400 !important;\n}\n\n.container {\n  width: 100px;\n  background-color: var(--ion-color-green);\n  overflow: hidden;\n  white-space: nowrap;\n\n  ::-webkit-scrollbar {\n    display: none;\n  }\n\n  .scroll {\n    overflow: auto;\n  }\n}\n\n.trans {\n  background-color: var(--ion-header-light-background) !important;\n}\n\n@media screen and (max-width: 360px) {\n  [width-5] {\n    max-width: 7% !important;\n  }\n}\n\n.validate-btn {\n  height: 30px !important;\n  max-width: 100px;\n}\n\n.attach-icon-font {\n  font-size: 1.8em !important;\n}\n\n.attach-upload-row {\n  .attachment-button {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 4px 0 4px 8px;\n  }\n\n  .attach-btn {\n    --padding-start: 0;\n    --padding-end: 0;\n    height: auto !important; \n  }\n   ion-icon {\n    margin-right: 6px !important;\n    flex-shrink: 0;\n  }\n}\n.attach-filename {\n  white-space: normal;\n  word-break: break-word;\n}\n.upload-col {\n  flex: 0 0 auto !important;\n  max-width: fit-content !important;\n  padding-right: 8px !important;\n\n  .validate-btn {\n    margin: 0 !important;\n  }\n}\n.fileUploadSize {\n  padding-left: 4px;\n  margin-top: 2px !important;\n  line-height: 1.5 !important;\n  white-space: normal !important;\n  word-break: break-word;\n  font-size: 12px;\n  padding-bottom: 6px;\n}\n.round_icon {\n  font-size: 27px !important;\n}\n\n[custom-radio-button] {\n  margin-left: auto !important;\n  display: block !important;\n  margin-top: 20px !important;\n}\n\n.select-disabled {\n  opacity: 1;\n}\n\n.custom-right-content {\n  .validate-btn-col {\n    padding: none !important;\n  }\n}\n\n.custom-margin {\n  margin: 10px !important;\n}\n\n.route_Name.custom-width {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.flightPlan_card {\n  button {\n    margin: 0 !important;\n  }\n\n  .green-status-icon {\n    color: var(--ion-color-green) !important;\n  }\n\n  .amber-status-icon,\n  .disabled-status-icon {\n    color: var(--ion-color-amber) !important;\n  }\n\n  .disable-select-box,\n  .disabled-status-icon {\n    opacity: 0.4;\n  }\n\n  .disabled-status-icon,\n  .green-status-icon,\n  .amber-status-icon {\n    margin-left: 0;\n    margin-top: 5px !important;\n    margin-bottom: 5px !important;\n    font-size: 2.4rem !important;\n  }\n\n  .download_option {\n    padding: 0 0 0 15px;\n  }\n\n  .left-content {\n    border-right: 1px solid var(--very-light-border) !important;\n    padding: 0px;\n  }\n\n  .right-content {\n    margin: auto;\n    text-align: center;\n\n    button {\n      padding: 0 5px;\n    }\n  }\n\n  [width-75] {\n    max-width: 75% !important;\n  }\n\n  [width-60] {\n    max-width: 60%;\n  }\n\n  [width-25] {\n    max-width: 25% !important;\n  }\n}\n\n.slide-item-btn {\n  color: var(--ion-color-primary) !important;\n  background-color: var(--ion-header-bg-color) !important;\n  border-right: 1px solid var(--ion-border-color) !important;\n}\n\n.slide-zoom {\n  padding: 7px;\n}\n\n.item-inner {\n  padding-right: none !important;\n}\n\n.dark-col-text {\n  color: var(--ion-primary-text) !important;\n}\n\n.legDetailsHeader {\n  padding-left: 10px;\n  background: #f6f6ff;\n  min-height: 33px !important;\n}\n\n.margin-bottom-10 {\n  margin-bottom: 12px;\n}\n\n.padding-top-5 {\n  padding-top: 5px;\n}\n\n.width-0 {\n  max-width: 0%;\n  padding: 0;\n}\n\n.width-10 {\n  max-width: 25%;\n}\n.positionOfIcon {\n  padding-bottom: 7px !important;\n}\n.trans {\n  background-color: var(--ion-header-light-background) !important;\n}\n.delete-icon {\n  margin-bottom: 4px !important;\n  font-size: 24px !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
